<template>
  <side-bar
     :logo="`/img/brand/logo-main.svg`"
  >
  <ul class="navbar-nav site-list-menu align-items-center ml-md-0">
      <base-dropdown
                     class="nav-item"
                     tag="li"
                     title-tag="a"
                     title-classes="nav-link pr-0">
        <a href="#" class="nav-link pr-0" @click.prevent slot="title-container">
          <div class="align-items-center selected-site-block">
            <div class="d-lg-block selected-site">
              <span class="mb-0 text-sm font-weight-bold">{{ selectedDomain }}</span>
              <span>{{ selectedSiteName }}</span>
            </div>
          </div>
        </a>

        <template>
          <div class="list-group site-list list-group-flush floating-menu"> 
          <a v-for="site in siteList" :key="site.id" :value="site.id" :href="`/subscribers/`+ site.id">
            <span>{{ site.site_name_jp }}</span><br><span> {{ site.site_domain }}</span>
          </a>
          </div>
        </template>
      </base-dropdown>
      </ul>
<!--
      <div class="navbar-inner" id="group1">
        <select  class="" name="sSite"  id="select1" @change="onSiteSelect">
          <option v-for="site in siteList" :key="site.id" :value="site.id" :selected="siteId == site.id">{{ site.site_name_jp }} {{ site.site_domain }}</option>
        </select>
      </div>
-->
<div class="menus-seperator"> </div>
    <template slot="links">
      <sidebar-item
        :link="{
          name: 'レポート',
          icon: 'ni parent-menu text-primary report',
        }"
        :class="parentMenu === `report` ? `active`:``"
      >
        <sidebar-item
          :link="{ name: 'ユーザー数', path: '/subscribers/'+siteId }"
          :class="menuId === `menuSubscriber` ? `active`:``"
        ></sidebar-item>
        <sidebar-item
          :link="{ name: '配信実績', path: '/history/'+siteId+'/sent' }"
          :class="{ 'active' : menuId === `menuSentList`}"
        ></sidebar-item>
      </sidebar-item>

      <sidebar-item
        :link="{
          name: 'プッシュ通知',
          icon: 'ni parent-menu text-primary push',
        }"
        :class="parentMenu === `push` ? `active`:``"
      >
        <sidebar-item
          :link="{ name: '新規作成', path: '/notifications/'+siteId+'/new' }"
          :class="menuId === `menuNewPush` ? `active`:``"
        ></sidebar-item>
        <sidebar-item
          :link="{ name: '下書き', path: '/notifications/'+siteId+'/draft' }"
          :class="menuId === `menuPushDraft` ? `active`:``"
        ></sidebar-item>
        <sidebar-item
          :link="{ name: '配信予約一覧', path: '/notifications/'+siteId+'/scheduledtosend' }"
          :class="menuId === `menuResevation` ? `active`:``"
        ></sidebar-item>
      </sidebar-item>

      <sidebar-item
        :link="{
          name: 'サイト管理',
          icon: 'ni parent-menu text-primary setting',
        }"
        :class="parentMenu === `setting` ? `active`:``"
      >
      <!--
      <sidebar-item
          :link="{ name: 'オーディエンス', path: '#' }"
          :class="menuId === `menuAudience` ? `link-inactive active`:`link-inactive`"
        ></sidebar-item>
      -->
      <!--
        <sidebar-item
          :link="{ name: 'オーディエンス', path: '/export-import/'+siteId }"
        ></sidebar-item>
        -->
        <sidebar-item v-show="permission_list['category-list'] ? true:false"
          :link="{ name: 'カテゴリー', path: '/category/'+ siteId+'/show' }"
          :class="menuId === `menuCategory` ? `active`:``"
        ></sidebar-item>
        <!--
        <sidebar-item
          :link="{ name: 'テストユーザー', path: '/settings/testuser/'+ siteId }"
          :class="menuId === `menuTestUser` ? `active`:``"
        ></sidebar-item>
      -->
        <sidebar-item  v-show="permission_list['site-list'] ? true:false"
          :link="{ name: 'サイト情報', path: '/sites/' }"
          :class="menuId === `menuSiteinfo` ? `active`:``"
        ></sidebar-item>
        
        <sidebar-item
          :link="{ name: '埋め込みコード', path: '/site/getembedcode/'+ siteId }"
          :class="menuId === `menuEmbedcode` ? `active`:``"
        ></sidebar-item>
<!--
        <sidebar-item
          :link="{ name: 'オプトイン設定', path: '/opt-in/'+ siteId }"
          :class="menuId === `menuOptin` ? `active`:``"
        ></sidebar-item>
-->
      </sidebar-item>
      <!--
      <sidebar-item
        :link="{
          name: 'ユーザー',
          icon: 'ni parent-menu text-primary user',
        }"
      >

       <sidebar-item
          :link="{ name: 'ユーザー一覧', path: '#' }"
          :class="`link-inactive`"
        ></sidebar-item>
        <sidebar-item
          :link="{ name: 'ロール', path: '#' }"
          :class="`link-inactive`"
        ></sidebar-item>
        <sidebar-item
          :link="{ name: '許可', path: '#' }"
          :class="`link-inactive`"
        ></sidebar-item>
      
        <sidebar-item
          :link="{ name: 'ユーザー一覧', path: '/users/' }"
        ></sidebar-item>
        <sidebar-item
          :link="{ name: 'ロール', path: '/roles/' }"
        ></sidebar-item>
      </sidebar-item>
-->        
      <sidebar-item v-show="accountVisible"
        :link="{
          name: 'アカウント管理',
          icon: 'ni parent-menu text-primary account',
        }"
        :class="parentMenu === `account` ? `active`:``"
      >
        
        <sidebar-item v-show="permission_list['user-create'] === true ? true:false"
          :link="{ name: 'アカウント作成', path: '/users/create' }"
          :class="menuId === `menuUserCreate` ? `active`:``"
        ></sidebar-item>
        <!--
        <sidebar-item
          :link="{ name: '契約社アカウント一覧', path: '/admin' }"
          :class="menuId === `menuAdminList` ? `active`:``"
        ></sidebar-item>
        
        <sidebar-item
          :link="{ name: '契約サイト一覧', path: '#' }"
          :class="menuId === `menuSiteList` ? `link-inactive active`:`link-inactive`"
          :id="`menuSiteList`"
        ></sidebar-item>
        -->
        <sidebar-item v-show="permission_list['user-list'] === true ? true:false"
          :link="{ name: 'アカウント一覧', path: '/users/' + siteId + '/list' }"
          :class="menuId === `menuAccountList` ? `active`:``"
        ></sidebar-item>
        <!--
        <sidebar-item v-show="permission_list['user-delete'] === true === true ? true:false"
          :link="{ name: 'アカウントの編集・削除', path: '/users/' }"
          :class="menuId === `menuAccountDelete` ? `active`:``"
        ></sidebar-item>
        -->
      </sidebar-item>
    </template>

    <template slot="links-after">
      <span class="version">Push L Ver. 1.0.0</span>
    </template>
  </side-bar>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';


function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}


export default {
  components: {
   
  },
  props: ['siteListData'],
  data() {
    return {
      // Our data object that holds the Laravel paginator data
       //window.PushL.site_id,
       siteId:0,
      siteList:null,
      parentMenu:"",
      menuId:"",
      permission_list:[],
      accountVisible: true,
      selectedSite:"",
      selectedDomain:"",
      selectedSiteName:"",
      events: {
      change: function () {
        console.log('close event called')
        this.$sidebar.displaySidebar(false);
      }
    },
    }
},
  methods: {
    
    initScrollbar() {
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        initScrollbar('sidenav');
      }
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    
   
    onSiteSelect(event) {
      const target = event.target;
      const val = target.value;
      
      this.siteId = val;
      window.PushL.site_id = this.siteId;
      window.location.href="/subscribers/" + this.siteId;
      this.setSelectedSite();
    },

    setSelectedSite() {
      for(let i=0; i< this.siteList.length; i++) {
          if(this.siteList[i].id == this.siteId) {
            this.selectedDomain = this.siteList[i].site_domain;
            this.selectedSiteName = this.siteList[i].site_name_jp;
            return;
          }
      }
    }
  },
  mounted() {
    this.initScrollbar()
    this.siteList= JSON.parse(this.siteListData);
    this.siteId = window.PushL.site_id;
    this.userId = window.PushL.user.id;
    this.parentMenu = window.PushL.selected_menu.parent_menu;
    this.menuId = window.PushL.selected_menu.menu;
    const permission = window.PushL.permission_list;
    this.permission_list = permission;
    this.accountVisible = permission['user-create'] ? true : permission['user-delete'] ? true: permission['user-list'] ? true : permission['user-edit'] ? true:false;
    this.setSelectedSite();
  }
};
</script>
<style lang="scss">

.link-inactive span{
color:#d6d6d6;
}

.navbar-vertical.navbar-expand-xs .site-list-menu.navbar-nav .nav-link {
  padding: .5rem 0 .5rem .5rem;
}

.site-list-menu .nav-item a.nav-link {
  color: rgba(0, 0, 0, 0.6);
  /*border:1px solid #676767;*/
  font-size:0.875rem;
  width:100%;
  background-position-y: 8px;
  white-space: normal;
  word-wrap: break-word;
  position:relative;
  border-radius: 4px;
  box-shadow: 0 0 0 2px rgb(255, 255, 255), 0.1em 0.1em .6em rgba(0, 0, 0, 0.3);
 }

.site-list-menu .nav-item a.nav-link::after {
  position:absolute;
  background-position-y: 8px;
  right: 0;
  content: url("data:image/svg+xml;utf8,<svg fill='rgba(0, 0, 0, 0.6)' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>")
}

.site-list-menu {
  z-index:9;
  position:absolute;
  width: 92%;
  /*border: 1px solid #dedede;*/
  /*box-shadow: 0 0 0 2px rgb(255, 255, 255), 0.1em 0.1em .6em rgba(0, 0, 0, 0.3);*/
  left:4%;
}
.menus-seperator {
  margin-bottom: 55px;
}
.site-list {
  margin-bottom:0;
}
.site-list a {
  margin-bottom:0;
  color:rgba(0, 0, 0, 0.6);
  margin: 10px 10px 0;
}

.site-list-menu .nav-item {
  width: 90%;
}

.selected-site span{
  display: block;
  height: 20px;
  overflow: hidden;
}

.g-sidenav-hidden .selected-site {
  display:none;
}

</style>